import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { User } from '@/services/user.service'

export const useMultipleCompanyAccessStore = defineStore('multipleCompanyAccess', () => {
  const hasMultipleCompanyAccess = ref(false)

  const getHasMultipleCompanyAccess = () => {
    return hasMultipleCompanyAccess.value
  }

  const setHasMultipleCompanyAccess = (hasMultipleCompanyAccessData: User) => {
    hasMultipleCompanyAccess.value = hasMultipleCompanyAccessData.hasMultipleCompanyAccess || false
  }

  return {
    getHasMultipleCompanyAccess,
    setHasMultipleCompanyAccess,
  }
})